import React, { useState, useEffect } from 'react';
import SalaForm from './SalaForm';
import { toast } from 'react-toastify';
import { isSafeUrl, isValidUrl } from './validador';
import ProcessoSala from '../../model/ProcessoSala';
import { SalaViewModel } from '../../viewmodel/ProcessoSalaViewModel';
import { useParams } from 'react-router-dom';
import { useProcessoContext } from '../../Routes/context/ProcessoUsuarioContext';
import { useBreadcrumbs } from '../../Routes/BreadcrumbContext';
import { createBreadcrumbs } from '../../utils/breadcrumbUtils';

const DefinirSalaEspera: React.FC = () => {
    const { processoId } = useParams();
    const [salaEspera, setSalaEspera] = useState<ProcessoSala[]>([]);
    const [url, setUrl] = useState('');
    const [editId, setEditId] = useState<string | null>(null);
    const { processo } = useProcessoContext();

    const { setBreadcrumbs } = useBreadcrumbs();    
    useEffect(() => {
        setBreadcrumbs(createBreadcrumbs.fromProcessos([
            { path: `/processos/${processo?.id}/sala-espera`, breadcrumb: `Sala de Espera`},
        ]));
      }, [setBreadcrumbs, processo]);

      useEffect(() => {
        async function fetchSalas() {
            try {
                const salas = await SalaViewModel.obterSalaPorId(processoId!);
                
                if (salas.length === 0) {
                    toast.info('Nenhuma sala definida ou disponível no momento.');
                } else {
                    setSalaEspera(salas);
                }
            } catch (error: unknown) {
                if (error instanceof Error) {
                    console.error('Erro ao carregar as salas:', error.message);
                    toast.info('Nenhuma sala definida ou disponível no momento.');
                } else {
                    console.error('Erro ao obter as salas:', error);
                    toast.error('Erro desconhecido ao obter as salas.');
                }
            }
        }
    
        fetchSalas();
    }, [processoId]);
    

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!isValidUrl(url) || !isSafeUrl(url)) {
            toast.error('Por favor, insira uma URL válida e segura.');
            return;
        }
        if (salaEspera.length >= 1 && editId === null) {
            toast.error('Você só pode criar até 1 sala de espera.');
            return;
        }
        try {
            if (editId === null) {
                const novaSalaObj: ProcessoSala = { id: '', salaUrl: url };
                const novaSala = await SalaViewModel.criarSala(novaSalaObj, processoId ? processoId : '');
                setSalaEspera([...salaEspera, novaSala]);
                toast.success('Sala criada.');
            } else {
                await SalaViewModel.patchLinkSala(editId, url);
                setSalaEspera(salaEspera.map(item => (item.id === editId ? { ...item, salaUrl: url } : item)));
                setEditId(null);
                toast.success('Link da sala atualizado.');
            }
            setUrl('');
        } catch (error: unknown) {
            if (error instanceof Error) {
                console.error('Erro ao criar/atualizar sala:', error.message);
                toast.error(error.message || 'Erro ao criar/atualizar sala.');
            } else {
                console.error('Erro ao criar/atualizar sala:', error);
                toast.error('Erro desconhecido ao criar/atualizar sala.');
            }
        }
    };

    const handleEdit = (id: string) => {
        const item = salaEspera.find(item => item.id === id);
        if (item) {
            setUrl(item.salaUrl);
            setEditId(id);
        }
    };

    return (
        <div className="container">
            <h1 className="text-center my-3">Sala de Espera</h1>
            <SalaForm
                items={salaEspera}
                url={url}
                editId={editId}
                setUrl={setUrl}
                handleSubmit={handleSubmit}
                handleEdit={handleEdit}
            />
        </div>
    );
};

export default DefinirSalaEspera;
